import { defineMessages } from 'react-intl';

export default defineMessages({
  titlePrefix: {
    id: 'sku-orders.flyout.title-prefix',
    defaultMessage: 'Order ID:',
  },
  sectionCustomer: {
    id: 'sku-orders.flyout.section-customer',
    defaultMessage: 'Customer',
  },
  contactCustomer: {
    id: 'sku-orders.flyout.contact-customer',
    defaultMessage: 'Contact customer',
  },
  reportUser: {
    id: 'sku-orders.flyout.report-user',
    defaultMessage: 'Report user',
  },
  infoLocation: {
    id: 'sku-orders.flyout.info-location',
    defaultMessage: 'Location',
  },
  infoPickUpTime: {
    id: 'sku-orders.flyout.info-pick-up-time',
    defaultMessage: 'Pick up time',
  },
  sectionOrderDetails: {
    id: 'sku-orders.flyout.section-order-details',
    defaultMessage: 'Order details',
  },
  totalPayout: {
    id: 'sku-orders.flyout.total-payout',
    defaultMessage: 'Total payout',
  },
  itemOutOfStock: {
    id: 'sku-orders.flyout.item-out-of-stock',
    defaultMessage: 'Item out of stock',
  },
  customerMissedPickup: {
    id: 'sku-orders.flyout.customer-missed-pickup',
    defaultMessage: 'Customer missed pickup',
  },
  cancelOrder: {
    id: 'sku-orders.flyout.cancel-order',
    defaultMessage: 'Cancel order',
  },
  markFulfilled: {
    id: 'sku-orders.flyout.mark-fulfilled',
    defaultMessage: 'Mark as fulfilled',
  },
  close: {
    id: 'sku-orders.flyout.close',
    defaultMessage: 'Close',
  },
  cancelledStatus: {
    id: 'sku-orders.flyout.cancelled-status',
    defaultMessage: 'Cancelled',
  },
  lifecycleActionMarkedFulfilled: {
    id: 'sku-orders.flyout.lifecycle-action-marked-fulfilled',
    defaultMessage: 'marked fulfilled',
  },
  lifecycleActionCancelled: {
    id: 'sku-orders.flyout.lifecycle-action-cancelled',
    defaultMessage: 'cancelled',
  },
  lifecycleActionMarkedAsMissed: {
    id: 'sku-orders.flyout.lifecycle-action-marked-as-missed',
    defaultMessage: 'marked as missed',
  },
  lifecycleAgentAutomatic: {
    id: 'sku-orders.flyout.lifecycle-agent-automatic',
    defaultMessage: 'automatically',
  },
  lifecycleAgentCustomer: {
    id: 'sku-orders.flyout.lifecycle-agent-customer',
    defaultMessage: 'by customer',
  },
  lifecycleAgentPartner: {
    id: 'sku-orders.flyout.lifecycle-agent-partner',
    defaultMessage: 'by partner',
  },
  lifecycleAgentClasspass: {
    id: 'sku-orders.flyout.lifecycle-agent-classpass',
    defaultMessage: 'by ClassPass support',
  },
  lifecycleDescription: {
    id: 'sku-orders.flyout.lifecycle-description',
    defaultMessage: 'Order {action} {agent} on {date} at {time}',
  },
  markedOutOfStock: {
    id: 'sku-orders.flyout.marked-out-of-stock',
    defaultMessage: 'Marked out of stock',
  },
  itemActions: {
    id: 'sku-orders.flyout.item-actions',
    defaultMessage: 'Item actions',
  },
});
